import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { NaturezaVendaFilter } from '../filter';
import { NaturezaVenda } from '../natureza-venda';

@Injectable({
    providedIn: 'root'
})
export class NaturezaVendaTypeaheadHttpService {
    private pathApi: string;

    constructor(private configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/naturezavenda`
    }

    /** Pesquisa as naturezas de vendas para o typeahead */
    search(filter: NaturezaVendaFilter, limit: number): Observable<NaturezaVenda[]> {
       // Params
       let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);

        return this.customHttp.get<NaturezaVenda[]>(this.pathApi, {params});
    }
}
